import { render, staticRenderFns } from "./expressReturn.vue?vue&type=template&id=019ebc70&scoped=true"
import script from "./expressReturn.vue?vue&type=script&lang=js"
export * from "./expressReturn.vue?vue&type=script&lang=js"
import style0 from "./expressReturn.vue?vue&type=style&index=0&id=019ebc70&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019ebc70",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('019ebc70')) {
      api.createRecord('019ebc70', component.options)
    } else {
      api.reload('019ebc70', component.options)
    }
    module.hot.accept("./expressReturn.vue?vue&type=template&id=019ebc70&scoped=true", function () {
      api.rerender('019ebc70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/returnCenter/expressReturn.vue"
export default component.exports